import {createAction, createAsyncAction} from 'typesafe-actions';
// @ts-ignore — @adobe/redux-saga-promise ships no type declarations
import {createPromiseAction} from '@adobe/redux-saga-promise';
import {APIErrorInterface} from '../../types';
import {
    AdapterHealth,
    Agent,
    AiAgentListRequest,
    AiAgentsResponse,
    AssignAgentPhoneError,
    AssignAgentPhoneResponse,
    TenantSession,
    VoiceAiConfig,
} from '../../types/AiAgent';

export const getAdapterHealth = createAsyncAction(
    'GET_ADAPTER_HEALTH',
    'GET_ADAPTER_HEALTH_SUCCESS',
    'GET_ADAPTER_HEALTH_FAILURE',
)<undefined, AdapterHealth, APIErrorInterface | undefined>();

export const getVoiceAiConfig = createAsyncAction(
    'GET_VOICE_AI_CONFIG',
    'GET_VOICE_AI_CONFIG_SUCCESS',
    'GET_VOICE_AI_CONFIG_FAILURE',
)<undefined, VoiceAiConfig | null, APIErrorInterface | undefined>();

export const updateVoiceAiConfig = createAsyncAction(
    'UPDATE_VOICE_AI_CONFIG',
    'UPDATE_VOICE_AI_CONFIG_SUCCESS',
    'UPDATE_VOICE_AI_CONFIG_FAILURE',
)<{service_name: string}, VoiceAiConfig, APIErrorInterface | undefined>();

export const refreshTenant = createAsyncAction(
    'REFRESH_TENANT',
    'REFRESH_TENANT_SUCCESS',
    'REFRESH_TENANT_FAILURE',
)<undefined, TenantSession, APIErrorInterface | undefined>();

export const getAiAgentsList = createAsyncAction(
    'GET_AI_AGENTS_LIST',
    'GET_AI_AGENTS_LIST_SUCCESSED',
    'GET_AI_AGENTS_LIST_FAILED',
)<AiAgentListRequest, AiAgentsResponse, {error?: string}>();

export const loadAiAgentsPage: any = createPromiseAction('LOAD_AI_AGENTS_PAGE');

export const assignAgentPhone = createAsyncAction(
    'ASSIGN_AGENT_PHONE',
    'ASSIGN_AGENT_PHONE_SUCCESS',
    'ASSIGN_AGENT_PHONE_FAILURE',
)<{agent_id: string}, AssignAgentPhoneResponse, AssignAgentPhoneError>();

export const clearAssignAgentPhoneError = createAction(
    'CLEAR_ASSIGN_AGENT_PHONE_ERROR',
)();

export const findAiAgentBySipUri = createAsyncAction(
    'FIND_AI_AGENT_BY_SIP_URI',
    'FIND_AI_AGENT_BY_SIP_URI_SUCCESS',
    'FIND_AI_AGENT_BY_SIP_URI_FAILURE',
)<{sipUri: string}, Agent | null, APIErrorInterface | undefined>();
